import React from 'react';
import { Loader2 } from 'lucide-react';

export const RoleAssignmentForm = ({
  selectedEmployee,
  assignmentForm,
  setAssignmentForm,
  assignmentOptionsLoading,
  assignmentOptionsError,
  assignmentFactories,
  assignmentDepartments,
  assignmentRoles,
  assigning,
  assignmentSuccessMessage,
  assignmentErrorMessage,
  onAssign
}) => {
  if (!selectedEmployee) return null;

  const employeeName = selectedEmployee.first_name && selectedEmployee.last_name
    ? `${selectedEmployee.first_name} ${selectedEmployee.last_name}`
    : selectedEmployee.first_name || selectedEmployee.last_name || 'N/A';

  return (
    <div className="mt-8 mb-6">
      <div className="rounded-2xl border border-gray-700 bg-gray-800 shadow-lg w-full min-w-0">
        <div className="px-4 sm:px-6 py-4 border-b border-gray-700">
          <h2 className="text-xl font-semibold text-white">
            Asignación de roles
          </h2>
          <p className="mt-1 text-sm text-gray-400">
            Empleado seleccionado: <span className="font-medium text-white">{employeeName}</span>
          </p>
        </div>
        <div className="p-4 sm:p-6 w-full min-w-0">
          {assignmentOptionsLoading && (
            <div className="flex items-center gap-2 text-gray-400 text-sm">
              <Loader2 className="w-4 h-4 animate-spin" />
              Cargando opciones...
            </div>
          )}
          {assignmentOptionsError && !assignmentOptionsLoading && (
            <div className="rounded-lg border border-red-800 bg-red-900/20 p-4 mb-4">
              <p className="text-red-300 text-sm">{assignmentOptionsError}</p>
            </div>
          )}
          {!assignmentOptionsLoading && (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">Fábrica</label>
                <select
                  value={assignmentForm.factoryId}
                  onChange={(e) => {
                    const factoryId = e.target.value;
                    setAssignmentForm(prev => ({ ...prev, factoryId, departmentId: '', roleId: '' }));
                  }}
                  className="w-full px-4 py-2 rounded-lg border border-gray-600 bg-gray-700 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">Seleccione fábrica...</option>
                  {assignmentFactories.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name ?? item.asset_code ?? item.id}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">Departamento</label>
                <select
                  value={assignmentForm.departmentId}
                  onChange={(e) => {
                    const departmentId = e.target.value;
                    setAssignmentForm(prev => ({ ...prev, departmentId, roleId: '' }));
                  }}
                  disabled={!assignmentForm.factoryId}
                  className="w-full px-4 py-2 rounded-lg border border-gray-600 bg-gray-700 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-60"
                >
                  <option value="">Seleccione departamento...</option>
                  {assignmentDepartments.map((item) => (
                    <option key={`${assignmentForm.factoryId}-${item.id}`} value={item.id}>
                      {item.name ?? item.code ?? item.id}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">Rol</label>
                <select
                  value={assignmentForm.roleId}
                  onChange={(e) => setAssignmentForm(prev => ({ ...prev, roleId: e.target.value }))}
                  disabled={!assignmentForm.departmentId}
                  className="w-full px-4 py-2 rounded-lg border border-gray-600 bg-gray-700 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-60"
                >
                  <option value="">Seleccione rol...</option>
                  {assignmentRoles.map((item) => (
                    <option key={`${assignmentForm.departmentId}-${item.id}`} value={item.id}>
                      {item.name ?? item.description ?? item.id}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}
          <div className="mt-4 flex items-center gap-3 flex-wrap">
            <button
              type="button"
              onClick={onAssign}
              disabled={
                assigning ||
                !assignmentForm.factoryId ||
                !assignmentForm.departmentId ||
                !assignmentForm.roleId ||
                assignmentOptionsLoading
              }
              className="inline-flex items-center gap-2 px-4 py-2 rounded-lg border border-blue-600 bg-blue-600 text-white text-sm font-medium hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {assigning && <Loader2 className="w-4 h-4 animate-spin" />}
              Asignar
            </button>
            {assignmentSuccessMessage && (
              <div className="rounded-lg border border-green-800 bg-green-900/20 px-4 py-2">
                <p className="text-green-300 text-sm">{assignmentSuccessMessage}</p>
              </div>
            )}
            {assignmentErrorMessage && (
              <div className="rounded-lg border border-red-800 bg-red-900/20 px-4 py-2">
                <p className="text-red-300 text-sm">{assignmentErrorMessage}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
